import { useState } from "react";
import { PageHeader } from "@/components/layout/PageHeader";
import { SearchForm } from "@/components/search/SearchForm";
import { JobProgress } from "@/components/search/JobProgress";
import { OverviewStats } from "@/components/search/OverviewStats";
import { BlockingAlert } from "@/components/search/BlockingAlert";

const STORAGE_KEY = "leadradar.activeJob";

export default function NewSearch() {
  const [activeJobId, setActiveJobId] = useState(() => localStorage.getItem(STORAGE_KEY));

  const onCreated = (id) => {
    localStorage.setItem(STORAGE_KEY, id);
    setActiveJobId(id);
  };

  return (
    <div data-testid="new-search-page">
      <PageHeader
        index="01"
        title="Nouvelle Recherche"
        subtitle="Interrogez et fusionnez en une seule passe les annuaires suisses, Google Maps, le Registre du Commerce et les sites web des entreprises."
      />
      <BlockingAlert />
      <div className="grid grid-cols-1 gap-6 xl:grid-cols-5">
        <div className="xl:col-span-3">
          <SearchForm onCreated={onCreated} />
        </div>
        <div className="xl:col-span-2">
          <OverviewStats />
        </div>
      </div>
      <div className="mt-10">
        <JobProgress jobId={activeJobId} />
      </div>
    </div>
  );
}
